import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Alert, Card, Row, Col } from "antd";
import CompanyLogo from "../../images/company_logo.jpg";
import TATLogo from "../../images/tat_logo.jpg";
import KBZImage from "../../images/kbz_pay.jpg";
import AYAImage from "../../images/aya_pay.jpg";
import CBImage from "../../images/cb_pay.jpg";
import OKImage from "../../images/ok_pay.png";
import VISACard from "../../images/visa.png";
import MASTERCard from "../../images/master.png";
import MPU from "../../images/mpu.png";
import MMQRImage from "../../images/mmqr.png";

function LoginPage() {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async () => {
    setError(""); // Clear previous errors
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BACKEND_URL}/v1/auth/login`,
        credentials,
        {
          headers: {
            // Send the token (if needed) in the Authorization header
            Authorization: `Bearer `,
          },
        },
      );
      var loginTime = new Date(); // Store the current timestamp

      // loginTime.setHours(loginTime.getHours() + 2);
      loginTime.setMinutes(loginTime.getMinutes() + 5);

      loginTime = loginTime.getTime();
      localStorage.setItem(
        "loginUser",
        JSON.stringify(response.data.loginUserDTO),
      );
      localStorage.setItem(
        "loginUserToken",
        JSON.stringify(response.data.token),
      );
      localStorage.setItem("loginTime", loginTime);

      window.dispatchEvent(new Event("storage"));
      navigate("/");
    } catch (error) {
      console.error("Login Failed:", error.response?.data || error.message);
      setError("Invalid username or password. Please try again.");
    }
  };

  return (
    <Row justify="center" style={{ marginTop: "50px" }}>
      <Col xs={24} sm={16} md={12} lg={8}>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Centers horizontally
            alignItems: "center", // Centers vertically
            marginBottom: "20px", // Adds space below the image
          }}
        >
          <img
            src={CompanyLogo}
            className="logo"
            alt="logo"
            style={{
              height: "70px",
              width: 70,
              marginRight: 30,
            }}
          />

          <img
            src={TATLogo}
            className="logo"
            alt="logo"
            style={{
              height: "70px",
              width: 70,
            }}
          />
        </div>
        <Card
          //   title="Login"
          style={{
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          {/* Error Message */}
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: "16px" }}
            />
          )}

          {/* Login Form */}
          <Form layout="vertical" onFinish={handleSubmit}>
            {/* Username Field */}
            <Form.Item
              label="Username"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please enter your username",
                },
              ]}
            >
              <Input
                name="username"
                value={credentials.username}
                onChange={handleChange}
                placeholder="Enter your username"
              />
            </Form.Item>

            {/* Password Field */}
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter your password",
                },
              ]}
            >
              <Input.Password
                name="password"
                value={credentials.password}
                onChange={handleChange}
                placeholder="Enter your password"
              />
            </Form.Item>

            {/* Submit Button */}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ backgroundColor: "#585656" }}
                block
              >
                Login
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <div
          style={{
            display: "flex",
            justifyContent: "center", // Centers horizontally
            alignItems: "center", // Centers vertically
            marginBottom: "20px", // Adds space below the image
            marginTop: "20px",
          }}
        >
          <img
            src={MMQRImage}
            className="logo"
            alt="logo"
            style={{
              height: "40px",
              width: 40,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
          <img
            src={KBZImage}
            className="logo"
            alt="logo"
            style={{
              height: "40px",
              width: 40,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />

          <img
            src={AYAImage}
            className="logo"
            alt="logo"
            style={{
              height: "40px",
              width: 40,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
          <img
            src={CBImage}
            className="logo"
            alt="logo"
            style={{
              height: "40px",
              width: 40,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
          <img
            src={OKImage}
            className="logo"
            alt="logo"
            style={{
              height: "40px",
              marginRight: 30,
              width: 40,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <img
            src={MPU}
            className="logo"
            alt="logo"
            style={{
              height: "50px",
              width: 50,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
          <img
            src={VISACard}
            className="logo"
            alt="logo"
            style={{
              height: "50px",
              width: 50,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
          <img
            src={MASTERCard}
            className="logo"
            alt="logo"
            style={{
              height: "50px",
              width: 50,
              marginRight: 30,
              objectFit: "contain",
              borderRadius: "5px",
            }}
          />
        </div>

        <div
          style={{
            textAlign: "center", // Center the copyright text
            fontSize: "15.5px", // Small font size
            color: "#888", // Lighter color for the text
            marginTop: "20px", // Space above the copyright text
            fontWeight: "bold",
          }}
        >
          Copyright &copy; {new Date().getFullYear()}, Powered by Almega
          Insights and partner with TAT. All rights reserved.
        </div>
      </Col>
    </Row>
  );
}

export default LoginPage;
